import { Button, HStack } from "@chakra-ui/react";

export const BlogPagination = ({ currentPage, totalPages, onPageChange }) => {
  const createPagination = () => {
    const pages = [];
    const delta = 2;

    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }

    return pages;
  };

  const handleScrollToTop = () => {
    // Change to scroll to #archive-container
    const archiveContainer = document.getElementById("archive-container");
    // if (archiveContainer) {
    //   archiveContainer.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //   });
    //   // After scrolling, adjust by 74px to account for fixed header or padding
    //   window.scrollBy({ top: 74, left: 0, behavior: "smooth" });
    // }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <HStack gap={4} justify="center" my={8}>
      <Button
        onClick={() => {
          // Scroll to top of page
          handleScrollToTop();
          onPageChange(currentPage - 1);
        }}
        isDisabled={currentPage === 1}
        size="sm"
        borderRadius="md"
        py={4}
        minHeight={10}
      >
        Previous
      </Button>
      {createPagination().map((page) => (
        <Button
          key={page}
          variant={page === currentPage ? "solid" : "outline"}
          py={page === currentPage ? 4 : 4}
          bg={page === currentPage ? "green.700" : "white"}
          onClick={() => {
            // Scroll to top of page
            handleScrollToTop();
            onPageChange(page);
          }}
          size="sm"
          borderRadius="md"
          minHeight={10}
          px={4}
        >
          {page}
        </Button>
      ))}
      <Button
        onClick={() => {
          // Scroll to top of page
          handleScrollToTop();
          onPageChange(currentPage + 1);
        }}
        isDisabled={currentPage === totalPages}
        size="sm"
        borderRadius="md"
        py={4}
        minHeight={10}
      >
        Next
      </Button>
    </HStack>
  );
};

export default BlogPagination;
